export default __webpack_public_path__ + "static/media/x33mall-banner-cn.46349918.webp";